"use client";

import React, { useEffect, useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import NotificationsBirthdayManager from "@/components/notificationsBirthday";
import NotificationsInactiveManager from "@/components/notificationsInactive";
import NotificationsScheduleManager from "@/components/notificationsSchedule";
import Spinner from "@/components/spinner/loading";

type Props = { dict: any };

const Notifications: React.FC<Props> = ({ dict }) => {
  const [active, setActive] = useState<string>("birthday");
  const [isSwitching, setIsSwitching] = useState<boolean>(false);

  useEffect(() => {
    if (!isSwitching) return;
    const timer = setTimeout(() => setIsSwitching(false), 250);
    return () => clearTimeout(timer);
  }, [isSwitching]);

  return (
    <div>
      <Tabs
        value={active}
        onValueChange={(v) => {
          setIsSwitching(true);
          setActive(v);
        }}
      >
        <TabsList className="grid w-full grid-cols-3 gap-2">
          <TabsTrigger value="birthday">
            {dict["Birthday templates"] || "Birthday"}
          </TabsTrigger>
          <TabsTrigger value="inactive">
            {dict["Inactive templates"] || "Inactive"}
          </TabsTrigger>
          <TabsTrigger value="schedule">
            {dict["Schedule templates"] || "Schedule"}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="birthday" className="mt-4">
          {isSwitching ? (
            <div className="flex justify-center py-8">
              <Spinner />
            </div>
          ) : (
            <NotificationsBirthdayManager dict={dict} />
          )}
        </TabsContent>
        <TabsContent value="inactive" className="mt-4">
          {isSwitching ? (
            <div className="flex justify-center py-8">
              <Spinner />
            </div>
          ) : (
            <NotificationsInactiveManager dict={dict} />
          )}
        </TabsContent>
        <TabsContent value="schedule" className="mt-4">
          {isSwitching ? (
            <div className="flex justify-center py-8">
              <Spinner />
            </div>
          ) : (
            <NotificationsScheduleManager dict={dict} />
          )}
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Notifications;
